import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=88bc5f82&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=88bc5f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bc5f82",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/product/exam/banner.vue
// module id = null
// module chunks = 